import { Checkbox, DataSource, ExcludableTextbox, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerRevenueReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxContainerssLocationId: ExcludableTextbox;
    excludabletextboxInbound: ExcludableTextbox;
    excludabletextboxOrderscustomerId: ExcludableTextbox;
    excludabletextboxOrdersrevenueCodeId: ExcludableTextbox;
    excludabletextboxOutbound: ExcludableTextbox;
    panelInboundTo1: Panel;
    panelInboundTo: Panel;
    panelOutboundFrom1: Panel;
    panelOutboundFrom: Panel;
    sourceCustomerRevenue: DataSource;
    switchIncludeFuel: Switch;
    switchIncludeRemainOrc: Switch;
    switchReportType: Switch;
    switchRollUp: Switch;
    textboxDate: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
    textboxInboundTo: Textbox;
    textboxInclude: Textbox;
    textboxOutboundFrom: Textbox;
}
